import React, { useRef, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import Pill from 'srcReact/components/common2/Pill'
import Navigate from '../Navigate'

function Expertises({ expertises, titleCSS, isMobile, isLoggedUser, firstName }) {
  const { t } = useTranslation()
  const [commonCount, setCommonCount] = useState(0)
  const expertiseRef = useRef()

  useEffect(() => {
    const commonExpertises = expertises?.filter((exp) => exp.is_common_with_logged_user === 1)
    setCommonCount(commonExpertises.length)
  }, [expertises])

  return (
    expertises?.length > 0 && (
      <Navigate
        itemRef={expertiseRef}
        isMobile={isMobile}
        totalItems={expertises}
        titleCSS={titleCSS}
        title={
          expertises.length === 1
            ? t('profile_light.expertise_title', {
                count: ` (${expertises.length})`,
                username: firstName
              })
            : t('profile_light.expertise_title_plural', {
                count: ` (${expertises.length})`,
                username: firstName
              })
        }>
        <div className={styles.expertises} ref={expertiseRef} id='expertises'>
          {expertises.map((expertise) => {
            return (
              <Pill
                key={expertise.id}
                shared={expertise.is_common_with_logged_user === 1}
                selected={true}
                text={expertise.name}
                type='expertise'
                className={styles.pill}
              />
            )
          })}
        </div>
      </Navigate>
    )
  )
}

export default Expertises
